import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import it from '../locales/it.json';
import type { Locale } from '@shared/types';

function cookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]!) : null;
}

export function detectLocale(): Locale {
  const q = new URLSearchParams(window.location.search).get('lang');
  const fromCookie = cookie('rx_lang');
  const nav = navigator.language?.slice(0, 2).toLowerCase();
  const pick = q ?? fromCookie ?? nav;
  return pick === 'it' ? 'it' : 'en';
}

export const i18n = i18next;

export async function initI18n(): Promise<void> {
  if (i18next.isInitialized) return;
  await i18next.use(initReactI18next).init({
    resources: { en: { translation: en }, it: { translation: it } },
    lng: detectLocale(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  document.documentElement.lang = i18next.language;
}

export async function setLocale(locale: Locale): Promise<void> {
  document.cookie = `rx_lang=${locale}; Path=/; Max-Age=${365 * 86400}; SameSite=Lax`;
  await i18next.changeLanguage(locale);
  document.documentElement.lang = locale;
}

export function currentLocale(): Locale {
  return i18next.language === 'it' ? 'it' : 'en';
}
